import Vue from "vue";
import axios from "./util/axios";
import VueAxios from "vue-axios";
import App from "./App";
import router from "./router";
import Vant, { Lazyload } from "vant";
import "vant/lib/index.css";
import store from "./store/index.js";
import Vuex from "vuex";


//引入ICONfontcss
import './assets/iconfont_mapcomponent/iconfont.css'
import './assets/iconfont_bsd/iconfont.css'
import './assets/iconfont_bsd/iconfont'


//注册日期格式化工具
import moment from "moment";
Vue.prototype.$moment = moment;

//注册百度地图
import BaiduMap from "vue-baidu-map";
Vue.use(BaiduMap, {
  ak: "bnWOYYSaSxMPSgZnr0m9mwunIEzKZEwq"
});
//注册对话框
import { Dialog } from "vant";
Vue.use(Dialog);

//引入Videojs
import Videojs from "video.js";
import "video.js/dist/video-js.css";
Vue.prototype.$video = Videojs;

//全局引入Element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

/**
 * 挂载XML转换为json字符串
 * 2020年08月15日10:00:05
 *   var jsonObj = _self.$x2js.xml2js(res.data);
 * */
import x2js from 'x2js' //xml数据处理插件
Vue.prototype.$x2js = new x2js() //创建x2js对象，挂到vue原型上


import {IHMapUtils} from "./components/map/common/IHMapUtils"
Vue.prototype.$olMapUtils = new IHMapUtils(); //创建x2js对象，挂到vue原型上

import AppLocalStorage from "./components/AppLocalStorage"
Vue.prototype.$appStorage = new AppLocalStorage();

import htmlToPdf from "./components/utils/html2canvas"
Vue.use(htmlToPdf)



Vue.use(VueAxios, axios);
Vue.use(Vuex);
Vue.use(Lazyload);
Vue.use(Vant);
Vue.use(axios);

Vue.config.productionTip = false;
Date.prototype.format = function(fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
};



//main.js
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
})




/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});




// import URLParameUtils from './util/URLParameUtils'
//
// console.log("Main.js");
// let uCode = URLParameUtils.getUrlKey("code");
// if(uCode==undefined)
// {
//   console.log("uCode = undefined && rediect url");
//   let redirectUrl = "http://cgzh.cafewallet.cn";
//   let appid = "wx6858ac0255b0c763";
//   const codeRequestUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid="+appid+"&redirect_uri=" + encodeURIComponent(redirectUrl) + "&response_type=code&scope=snsapi_base#wechat_redirect";
//   console.log("ucode = undefined && redirectUrl = ", codeRequestUrl);
//   window.location.href = codeRequestUrl;
// }
// else
// {
//   console.log("uCode read success && uCode = "+uCode);
// }



// WEBPACK FOOTER //
// ./src/main.js